import React from 'react';
import { List, Card, Icon, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import InlineEditIconButton from 'components/InlineEditIconButton';

export default function MenuProductsList({ menu, history, onRefresh }) {
  return menu.map((categoryProducts, index) => {
    const categoryName = categoryProducts[0];
    const products = categoryProducts[1];
    const categoryId = categoryProducts[2]; // Get category ID directly from the 3rd element
    
    return (
      <Card fluid key={index} style={{ boxShadow: 'none', border: 'none', borderBottom: '1px solid #eee', marginBottom: '24px' }}>
        <Card.Content style={{ padding: '16px 8px' }}>
          <Card.Header style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            fontSize: '1.6em',
            fontWeight: 'bold',
            marginBottom: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {categoryName}
              {categoryId && (
                <InlineEditIconButton
                  as={Link}
                  to={`/menu/categories/edit/${categoryId}`}
                  ariaLabel="Editar categoría"
                />
              )}
            </div>
            <div>
              {categoryId && (
                <Button 
                  size="tiny" 
                  icon 
                  circular 
                  primary
                  as={Link}
                  to={`/menu/products/new?categoryId=${categoryId}`}
                >
                  <Icon name="plus" />
                </Button>
              )}
            </div>
          </Card.Header>
          
          {products.length > 0 ? (
            <List divided relaxed>
              {products.map((product) => (
                <List.Item
                  key={product.id}
                  as={Link}
                  to={`/menu/products/${product.id}`}
                  style={{ 
                    padding: '16px 8px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    textDecoration: 'none', 
                    color: 'inherit' 
                  }}
                >
                  <List.Content style={{ flex: 1, minWidth: 0 }}>
                    <span style={{
                      fontSize: '1.6em',
                      fontWeight: 'normal',
                      lineHeight: 1.35,
                      wordBreak: 'break-word',
                    }}>
                      {product.name}
                      {(!product.hasOwnProperty('cost') || product.cost === null || product.cost === undefined || product.cost === '') ? (
                        <Icon
                          name="warning sign"
                          color="orange"
                          size="small"
                          style={{
                            marginLeft: '6px',
                            verticalAlign: '-0.06em',
                          }}
                          title="Falta agregar costo"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        />
                      ) : null}
                    </span>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          ) : (
            <div style={{ padding: '16px 0', color: '#666', fontSize: '1.3em' }}>
              No hay productos en esta categoría.
            </div>
          )}

        </Card.Content>
      </Card>
    );
  });
}